import routeName from '~/utils/route-name'

const publicRoutes = ['/login', '/forgot-password', '/reset-password'];

export default defineNuxtRouteMiddleware(async (to, from) => {
  const auth = useCookie<BearerToken>('auth')
  const {redirectToHorizon} = useHorizonAuth()
  const {getMe} = useAuth()
  const isAuthenticated = !!auth.value
  const isPublicRoute = publicRoutes.includes(to.path as any)

  // Case 1: User is on login page and already authenticated
  if (to.path === '/login' && isAuthenticated) {
    if (to.query.horizon_redirect !== undefined) {
      await getMe(); // avoid loop if token is expired
      return await redirectToHorizon()
    } else if (!to.redirectedFrom) {
      return navigateTo({name: routeName.campaignIndex})
    } else {
      return navigateTo(to.redirectedFrom.fullPath)
    }
  }

  // Case 2: User is on protected page and not authenticated
  if (!isPublicRoute && !isAuthenticated) {
    return navigateTo('/login')
  }
})
